import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertsKpiRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilityId: z.number().optional(),
});

const KpiResponseDtoSchema = z.object({
  count: z.number(),
  changePct: z.number().nullable(),
});

const GetAlertsKpiResponseDtoSchema = z.object({
  residents: KpiResponseDtoSchema,
  createdAlerts: KpiResponseDtoSchema,
  createdFlags: KpiResponseDtoSchema,
  activeAlerts: KpiResponseDtoSchema,
});

export type GetAlertsKpiRequestDto = z.infer<
  typeof _GetAlertsKpiRequestDtoSchema
>;
export type GetAlertsKpiResponseDto = z.infer<
  typeof GetAlertsKpiResponseDtoSchema
>;

export const getAlertsKpi = (
  params: GetAlertsKpiRequestDto,
  config?: AxiosRequestConfig<GetAlertsKpiRequestDto>
) => {
  return api
    .get('residents/alerts-kpi', { params, ...config })
    .then(responseContract(GetAlertsKpiResponseDtoSchema));
};
